import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { useApplicationModals } from "app/common/hooks";
import { IconButton } from "app/components/atoms/button";
import Table from "app/components/atoms/table";
import { useCollector } from "app/integration/common/hooks";
import MainLayout from "app/layouts/main";
import AppModals from "app/modals";

const breadcrumbItems = [
  { label: "Settings", href: "#" },
  { label: "Varian Warna", href: "#" },
];

function ColorVariantPage() {
  const { openModal, setPayloads } = useApplicationModals();

  const [colorVariants, setVariants, loader, collect] = useCollector({
    modelName: "colorVariant",
  });

  return (
    <MainLayout
      activeSidebarNavigation="settings"
      activeSidebarChild="color-variant"
      breadcrumbItems={breadcrumbItems}
      pageTitle="Varian Warna"
      headingButtons={[
        {
          label: "Tambah Varian Warna",
          type: "button",
          onClick: () => openModal("colorVariant.create"),
        },
      ]}
    >
      <AppModals
        items={[
          "colorVariant.create",
          "colorVariant.update",
          "colorVariant.delete",
        ]}
        onSuccess={{
          "colorVariant.create": () => collect(),
          "colorVariant.update": () => collect(),
          "colorVariant.delete": () => collect(),
        }}
      />
      <Table.Container>
        <Table.UtilitiesWrapper>
          <Table.SearchBarWrapper>
            <Table.SearchBarItemWrapper>
              {/* <SearchInput placeholder="Search" /> */}
            </Table.SearchBarItemWrapper>
          </Table.SearchBarWrapper>
          {/* <Table.UtilitiesButtonWrapper>
            <IconButton icon={PrinterIcon} />
          </Table.UtilitiesButtonWrapper> */}
        </Table.UtilitiesWrapper>
        <Table.Wrapper asIndex={false}>
          <Table.Header>
            <Table.HeaderRow>
              <Table.Heading>Varian Warna</Table.Heading>
              <Table.Heading></Table.Heading>
            </Table.HeaderRow>
          </Table.Header>
          <Table.Body>
            {colorVariants?.map((colorVariant, key) => (
              <Table.BodyRow key={key}>
                <Table.Cell>{colorVariant.name}</Table.Cell>
                <Table.Cell>
                  <div className="flex">
                    <IconButton
                      icon={PencilSquareIcon}
                      onClick={(e) => {
                        setPayloads("colorVariant.update", {
                          id: colorVariant.id,
                        });
                        openModal("colorVariant.update");
                      }}
                    />
                    {/* <IconButton
                      icon={TrashIcon}
                      onClick={(e) => {
                        setPayloads("colorVariant.delete", {
                          id: colorVariant.id,
                        });
                        openModal("colorVariant.delete");
                      }}
                    /> */}
                  </div>
                </Table.Cell>
              </Table.BodyRow>
            ))}
          </Table.Body>
        </Table.Wrapper>
      </Table.Container>
    </MainLayout>
  );
}

export default ColorVariantPage;
